module.exports = __webpack_public_path__ + "static/media/waveimaging.79bdf0fe.jpg";